export const TITRE_DETAIL_PAGE = "/titreDetail/";
export const LISTE_TITRES_PAGE = "/listTitres";
export const HOME_PAGE = "/home";
export const ROOT_PAGE = "/";
export const TITRE_HISTORIQUE_PAGE = "/tihistorique/";
export const CHANGEMENT_MDP_PAGE = "/changementmdp";
export const CONSULTATION_TITRES_PAGE = "/consultationTitres";
export const GESTION_TITRES_PAGE = "/gestionTitres";
export const GESTION_CAUTION_PAGE = "/gestionCautions";
// export const WEB_SERVICE_PAGE = "/webservice";
export const GO_BACK = -1;
